import { Tooltip } from 'primereact/tooltip';
import * as React from 'react';


export const PresentableLabel = () => {
    return <div className='flex-row ai-center'>
        <span>{__('js_files.presentable')}</span>&nbsp;
        <Tooltip target=".presentable-tooltip" baseZIndex={99999} position='top' content={__('js_files.presentable_description')} />
        <i className="iki iki-info presentable-tooltip" style={{ fontSize: '0.97em' }}></i>
    </div>
}
